var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e9776acda20cb58875088d46f1c043a7",
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0ZM11.844,22.277H8.58v-9.82h3.264ZM10.212,11.116h-.021a1.7,1.7,0,1,1,.042-3.393,1.7,1.7,0,1,1-.021,3.393Zm13.4,11.161H20.349V17.023c0-1.32-.472-2.22-1.654-2.22A1.786,1.786,0,0,0,17.021,16a2.24,2.24,0,0,0-.108.8v5.484H13.65s.043-8.9,0-9.82h3.264v1.391a3.239,3.239,0,0,1,2.942-1.622c2.147,0,3.757,1.4,3.757,4.42Z",
    fill: "#faf7f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0af33c9ece6d87c4130d17ee583c0213.svg";
export { ForwardRef as ReactComponent };